import { Layout } from 'react-admin';
import { CustomAppBar } from './AppBar';
import CustomMenu from './Menu';

export const CustomLayout = (props) => (
  <Layout {...props} appBar={CustomAppBar} menu={CustomMenu} />
);
